'use strict';
(function () {
  var _controller = 'identification.component.controller'
  angular.module('pentaApp')
    .controller(_controller, controller)
    .component('identification', {
      templateUrl: window.location.href.includes('/frontend/mobile') ? 'commons/components/identification/identification.component.html' : 'components/identification/identification.component.jade',
      controller: _controller,
      bindings: {
        identificationType: '=',
        identificationNumber: '=',
        origin: '@?', //- Origen de donde se llama el componente. 'LOGIN', 'SIGNUP', 'USER', 'ADDITIONAL-INFORMATION'
        required: '<?'
      }
    })

  controller.$inject = ['$scope', '$element'];
  function controller($scope, $element) {
    // METHODS
    $scope.changeType = changeType;
    $scope.checkValidation = checkValidation;
    $scope.getStyles = getStyles;

    // VARS
    var that = this;
    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    // INIT

    /// On component init
    this.$onInit = function () {
      $scope.identificationNumberTypes = (profile
        && profile.enterprise
        && profile.enterprise.identificationNumberTypes
        && profile.enterprise.identificationNumberTypes.length) ? profile.enterprise.identificationNumberTypes : (profile && profile.identificationNumberTypes && profile.identificationNumberTypes.length) ? profile.identificationNumberTypes : ['DNI', 'CUIL', 'RUT'];
      if (!this.identificationType) this.identificationType = $scope.identificationNumberTypes[0];
      setTimeout(function () { checkValidation(); }, 0)
    };

    /////////////////////
    // that.identificationType:
    // "CEDULA"
    // "PASSPORT"
    // "CARNET-RESIDENTE"
    // "CARNET-TEMPORAL"
    // "DNI"
    // "RUT"
    // "CUIT"
    function changeType() {
      if (!$scope.myComponentForm) return
      if (!that.identificationType) return setFormValid();
      checkValidation()
    }

    function checkValidation() {
      if (!$scope.myComponentForm) return
      switch (that.identificationType) {
        case "DNI": return validateDNI();
        case "CUIT": return validateCUIT();
        case "CUIL": return validateCUIL();
        case "RUT": return validateRUT();
        default: return setFormValid();
      }
    }

    function validateDNI() {
      setFormInvalid();
      if (!that.identificationNumber) return resetInputErrorMessage();
      if (!/^(\d{8})$|^(\d{2}\.{1}\d{3}\.\d{3})$/.exec(that.identificationNumber)) return setInputErrorMessage(i18next.t('DNI invalido, Ej. 99999999 o 99.999.999'))
      setFormValid();
    }

    function validateCUIT() {
      setFormInvalid();
      if (!that.identificationNumber) return resetInputErrorMessage();
      if (!/^(\b(30|33|34)\-{1}[0-9]{8}\-{1}[0-9]{1})$/.exec(that.identificationNumber)) return setInputErrorMessage(i18next.t('CUIT invalido, Ej. 99-99999999-9'))
      setFormValid();
    }

    function validateCUIL() {
      setFormInvalid();
      if (!that.identificationNumber) return resetInputErrorMessage();
      if (!/^(\b(20|23|24|27)\-{1}[0-9]{8}\-{1}[0-9]{1})$/.exec(that.identificationNumber)) return setInputErrorMessage(i18next.t('CUIT invalido, Ej. 99-99999999-9'))
      setFormValid();
    }

    function validateRUT() {
      setFormInvalid();
      if (!that.identificationNumber) return resetInputErrorMessage();
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.exec(that.identificationNumber)) return setInputErrorMessage(i18next.t('RUT invalido, Ej. 99999999-9 o 99999999-k'))
      var rutSplit = that.identificationNumber.split('-');
      var number = rutSplit[0];
      var checkDigit = rutSplit[1];
      if (checkDigit === 'K') checkDigit = 'k';
      var M = 0, S = 1;
      for (; number; number = Math.floor(number / 10)) {
        S = (S + number % 10 * (9 - M++ % 6)) % 11;
      }
      var result = S ? (S - 1) : 'k';
      if (result.toString() !== checkDigit) return setInputErrorMessage(i18next.t('El RUT ingresado no es válido'))
      setFormValid();
    }

    function setFormValid() {
      $scope.myComponentForm.identificationNumber.$setValidity("text", true);
    }

    function setFormInvalid() {
      $scope.myComponentForm.identificationNumber.$setValidity("text", false);
    }

    function setInputErrorMessage(err) {
      if (!err) err = i18next.t('Error');
      $scope.myComponentForm.identificationNumber.errorMessage = i18next.t(err);
    }

    function resetInputErrorMessage() {
      $scope.myComponentForm.identificationNumber.errorMessage = null
    }

    function getStyles(type) {
      var styles = [];
      if ($scope.$root.employeeApp) {
        if (type === 'SELECT') {
          if (that.origin === 'USER') styles.push('identification-select select-input select-input--material max-height-37');
          else styles.push('ai-input max-height-37');
        }
        if (type === 'INPUT') {
          if (that.origin === 'USER') styles.push('identification-input text-input text-input--material text-input--underbar max-height-37');
          else styles.push('ai-input');
        }
      } else {
        if (type === 'SELECT') {
          if (that.origin === 'LOGIN' || that.origin === 'SIGNUP' || that.origin === 'USER') styles.push('identification-select select-input select-input--material max-height-32');
          if (that.origin === 'ADDITIONAL-INFORMATION') styles.push('ai-input max-height-31');
        }
        if (type === 'INPUT') {
          if (that.origin === 'LOGIN' || that.origin === 'SIGNUP' || that.origin === 'USER') styles.push('identification-input text-input text-input--material text-input--underbar');
          if (that.origin === 'ADDITIONAL-INFORMATION') styles.push('ai-input');
        }
      }
      return styles;
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }
    //// FIN CTRL
  }
})();